/* MADE IN AKITA — theme scripts */
(function () {
  'use strict';

  /* ---------- Age gate ---------- */
  function initAgeGate() {
    var gate = document.querySelector('[data-mia-age]');
    if (!gate) return;
    var key = 'mia_age_ok';
    var ok = false;
    try { ok = localStorage.getItem(key) === '1'; } catch (e) {}
    if (ok || window.Shopify && window.Shopify.designMode) return;
    gate.classList.add('is-open');
    document.body.classList.add('mia-age-locked');
    // make everything behind the modal unreachable (keyboard + AT); the gate itself lives inside #header-group
    var behind = Array.prototype.filter.call(document.querySelectorAll('#header-group > *, #MainContent, body > footer'), function (el) { return !el.contains(gate); });
    behind.forEach(function (el) { try { el.inert = true; } catch (e) {} });
    function release() { behind.forEach(function (el) { try { el.inert = false; } catch (e) {} }); }
    var yes = gate.querySelector('[data-age-yes]');
    if (yes) setTimeout(function () { yes.focus(); }, 50);
    gate.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(gate.querySelectorAll('button,[tabindex="-1"]'), function (el) { return el.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !gate.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !gate.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    gate.querySelector('[data-age-yes]').addEventListener('click', function () {
      try { localStorage.setItem(key, '1'); } catch (e) {}
      gate.classList.remove('is-open');
      document.body.classList.remove('mia-age-locked');
      release();
    });
    gate.querySelector('[data-age-no]').addEventListener('click', function () {
      gate.classList.add('is-denied');
      var t = gate.querySelector('#mia-age-denied-title');
      if (t) { gate.setAttribute('aria-labelledby', 'mia-age-denied-title'); t.focus(); }
    });
  }

  /* ---------- Cart: active age confirmation before checkout (Alcoholwet / NVWA) ---------- */
  function initAgeCheck() {
    var attrKey = 'Age confirmation';
    function boxes() { return Array.prototype.slice.call(document.querySelectorAll('[data-mia-agecheck]')); }
    function ctasFor(box) { var n = box.nextElementSibling; while (n && !n.classList.contains('cart__ctas')) n = n.nextElementSibling; return n; }
    function paint() {
      boxes().forEach(function (box) {
        var input = box.querySelector('[data-mia-agecheck-input]');
        var ctas = ctasFor(box);
        var ok = !!(input && input.checked);
        box.classList.toggle('is-confirmed', ok);
        if (ok) { var err = box.querySelector('.mia-agecheck__error'); if (err) err.hidden = true; }
        if (ctas) {
          var btn = ctas.querySelector('.cart__checkout-button');
          if (btn) btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
          ctas.classList.toggle('mia-ctas--locked', !ok);
        }
      });
    }
    function save(checked) {
      var attrs = {};
      attrs[attrKey] = checked ? 'Customer confirmed legal drinking age (18+, 20+ where required) at ' + new Date().toISOString() : '';
      attrs['_age_confirmed_at'] = checked ? String(Math.floor(Date.now() / 1000)) : '';
      try {
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function () {});
      } catch (e) {}
    }
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.hasAttribute || !input.hasAttribute('data-mia-agecheck-input')) return;
      // mirror to the other instance (cart page + drawer can both be in the DOM)
      boxes().forEach(function (box) { var i = box.querySelector('[data-mia-agecheck-input]'); if (i && i !== input) i.checked = input.checked; });
      save(input.checked);
      paint();
    });
    // capture phase so we win over Horizon's own submit handling and native form validation
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.cart__checkout-button') : null;
      if (!btn) return;
      var ctas = btn.closest('.cart__ctas');
      var box = ctas ? ctas.previousElementSibling : null;
      while (box && !box.hasAttribute('data-mia-agecheck')) box = box.previousElementSibling;
      if (!box) return;
      var input = box.querySelector('[data-mia-agecheck-input]');
      if (input && input.checked) return;
      e.preventDefault(); e.stopPropagation();
      var err = box.querySelector('.mia-agecheck__error');
      if (err) err.hidden = false;
      box.classList.add('is-error');
      if (input) input.focus();
    }, true);
    // re-paint after Horizon re-renders the cart (section morph) and when the drawer opens
    var mo = new MutationObserver(function () { paint(); });
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    paint();
  }

  /* ---------- Product grid: sidebar filters / sort / pagination ---------- */
  function parsePrice(el) { return parseFloat(el.getAttribute('data-price') || '0'); }

  function initGrid(root) {
    var grid = root.querySelector('[data-mia-grid]');
    if (!grid) return;
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-filter-group]'));
    var sortSels = Array.prototype.slice.call(root.querySelectorAll('[data-mia-sort]'));
    var sortSel = sortSels[0] || null;
    var minIn = root.querySelector('[data-price-min]');
    var maxIn = root.querySelector('[data-price-max]');
    var minLbl = root.querySelector('[data-price-min-label]');
    var maxLbl = root.querySelector('[data-price-max-label]');
    var track = root.querySelector('[data-price-track]');
    var clearBtn = root.querySelector('[data-mia-clear]');
    var applyBtn = root.querySelector('[data-mia-apply]');
    var countEl = root.querySelector('[data-mia-count]');
    var pagesEl = root.querySelector('[data-mia-pages]');
    var side = root.querySelector('[data-mia-side]');
    var sideToggle = root.querySelector('[data-mia-side-toggle]');
    var perPage = parseInt(root.getAttribute('data-per-page') || '12', 10);
    var mode = root.getAttribute('data-filter-mode') || 'and';
    var state = { groups: {}, sort: 'recommended', min: null, max: null, page: 1 };
    var prefixes = {}, listed = {};
    var priceMax = maxIn ? parseFloat(maxIn.getAttribute('max') || '100') : 100;

    // read initial state from URL (?brewery=OKD&flavor=Dry&sort=price-asc&p=2). NB: `page` belongs to Shopify's
    // server-side pagination, the client pager uses `p` so a shared/reloaded URL never collides with it.
    var params = new URLSearchParams(location.search);
    inputs.forEach(function (inp) {
      var g = inp.getAttribute('data-filter-group');
      var v = inp.getAttribute('data-filter-value');
      if (inp.hasAttribute('data-filter-prefix')) prefixes[g] = inp.getAttribute('data-filter-prefix');
      if (v !== '__other__') (listed[g] = listed[g] || []).push(v);
      var want = params.getAll(g);
      if (want.indexOf(v) > -1) { setOn(inp, true); (state.groups[g] = state.groups[g] || []).push(v); }
    });
    if (params.get('sort') && sortSel) { sortSels.forEach(function (sel) { sel.value = params.get('sort'); }); state.sort = sortSel.value; }
    if (params.get('p')) state.page = Math.max(1, parseInt(params.get('p'), 10) || 1);
    var smooth = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    var ownKeys = inputs.map(function (i) { return i.getAttribute('data-filter-group'); }).concat(['sort', 'p']);

    function setOn(inp, on) {
      if (inp.type === 'checkbox') inp.checked = on; else inp.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    function isOn(inp) { return inp.type === 'checkbox' ? inp.checked : inp.getAttribute('aria-pressed') === 'true'; }
    function cards() { return Array.prototype.slice.call(grid.querySelectorAll('[data-mia-card]')); }

    function groupHit(tags, g, sel) {
      var prefix = prefixes[g] != null ? prefixes[g] : (root.getAttribute('data-prefix-' + g) || '');
      return sel.some(function (v) {
        if (v === '__other__') {
          var has = false, other = false;
          tags.forEach(function (t) {
            if (prefix === '' || t.indexOf(prefix) === 0) {
              var val = prefix === '' ? t : t.slice(prefix.length);
              if ((listed[g] || []).indexOf(val) > -1) has = true; else if (prefix !== '') other = true;
            }
          });
          return other && !has;
        }
        return tags.indexOf(prefix + v) > -1;
      });
    }

    function matches(card, ignoreGroup) {
      var tags = (card.getAttribute('data-tags') || '').split('|');
      var okAll = true, anyGroup = false, okAny = false;
      Object.keys(state.groups).forEach(function (g) {
        var sel = state.groups[g];
        if (!sel.length || g === ignoreGroup) return;
        anyGroup = true;
        if (groupHit(tags, g, sel)) okAny = true; else okAll = false;
      });
      var ok = mode === 'any' ? (!anyGroup || okAny) : okAll;
      var price = parsePrice(card);
      if (state.min != null && price < state.min) ok = false;
      if (state.max != null && state.max < priceMax && price > state.max) ok = false;
      return ok;
    }

    function sortCards(list) {
      var s = state.sort;
      return list.sort(function (a, b) {
        if (s === 'price-asc') return parsePrice(a) - parsePrice(b);
        if (s === 'price-desc') return parsePrice(b) - parsePrice(a);
        if (s === 'newest') return (parseInt(b.getAttribute('data-created') || '0', 10)) - (parseInt(a.getAttribute('data-created') || '0', 10));
        if (s === 'name') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        return (parseInt(a.getAttribute('data-index') || '0', 10)) - (parseInt(b.getAttribute('data-index') || '0', 10));
      });
    }

    function updateCounts() {
      var list = cards();
      inputs.forEach(function (inp) {
        var c = inp.parentNode.querySelector('[data-filter-count]');
        if (!c) return;
        var g = inp.getAttribute('data-filter-group'), v = inp.getAttribute('data-filter-value');
        var n = 0;
        list.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split('|');
          if (groupHit(tags, g, [v])) n++;
        });
        c.textContent = '(' + n + ')';
      });
    }

    function renderPages(total, cur) {
      if (!pagesEl) return;
      var pages = Math.max(1, Math.ceil(total / perPage));
      cur = Math.min(Math.max(1, cur || state.page), pages);
      // remember which button had focus so a click does not drop focus to <body>
      var prev = pagesEl.contains(document.activeElement) ? (document.activeElement.getAttribute('aria-label') || document.activeElement.textContent) : null;
      pagesEl.innerHTML = '';
      pagesEl.hidden = pages <= 1;
      if (pages <= 1) return;
      var prevLabel = pagesEl.getAttribute('data-prev-label') || 'Previous page';
      var nextLabel = pagesEl.getAttribute('data-next-label') || 'Next page';
      function btn(label, page, cur, dis, aria) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = label;
        if (aria) b.setAttribute('aria-label', aria);
        if (cur) b.setAttribute('aria-current', 'page');
        if (dis) b.disabled = true;
        b.addEventListener('click', function () { state.page = page; apply(true, true); });
        pagesEl.appendChild(b);
      }
      btn('\u2039', Math.max(1, cur - 1), false, cur === 1, prevLabel);
      var shown = [];
      for (var p = 1; p <= pages; p++) {
        if (p === 1 || p === pages || Math.abs(p - cur) <= 1) shown.push(p);
      }
      var last = 0;
      shown.forEach(function (p) {
        if (p - last > 1) { var gap = document.createElement('span'); gap.textContent = '\u2026'; pagesEl.appendChild(gap); }
        btn(String(p), p, p === cur, false, null);
        last = p;
      });
      btn('\u203a', Math.min(pages, cur + 1), false, cur === pages, nextLabel);
      if (prev) {
        var again = Array.prototype.filter.call(pagesEl.querySelectorAll('button'), function (b) { return !b.disabled && (b.getAttribute('aria-label') || b.textContent) === prev; })[0] || pagesEl.querySelector('button[aria-current]');
        if (again) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
      }
    }

    function apply(scroll, fromUser) {
      var list = cards();
      var visible = [];
      list.forEach(function (c) { if (matches(c)) visible.push(c); else c.hidden = true; });
      sortCards(list).forEach(function (c) { grid.appendChild(c); });
      visible = sortCards(visible);
      var pages = Math.max(1, Math.ceil(visible.length / perPage));
      var cur = Math.min(Math.max(1, state.page), pages); // clamp locally: a ?p=N deep link must survive until all pages are merged
      var start = (cur - 1) * perPage;
      visible.forEach(function (c, i) { c.hidden = !(i >= start && i < start + perPage); });
      root.classList.remove('is-loading');
      root.classList.toggle('is-empty', visible.length === 0);
      if (countEl) {
        var tpl = visible.length === 1 && countEl.getAttribute('data-template-one') ? countEl.getAttribute('data-template-one') : countEl.getAttribute('data-template');
        countEl.textContent = (tpl || '__COUNT__').replace('__COUNT__', visible.length);
      }
      renderPages(visible.length, cur);
      var active = Object.keys(state.groups).some(function (g) { return state.groups[g].length; }) || state.min != null || (state.max != null && state.max < priceMax);
      root.classList.toggle('has-filters', active);
      if (clearBtn) clearBtn.hidden = !active;
      if (fromUser) {
        // keep foreign params (utm_*, fbclid, preview_theme_id, ...) — only rewrite the keys this script owns
        var p = new URLSearchParams(location.search);
        ownKeys.forEach(function (k) { p.delete(k); });
        Object.keys(state.groups).forEach(function (g) { state.groups[g].forEach(function (v) { p.append(g, v); }); });
        if (state.sort !== 'recommended') p.set('sort', state.sort);
        if (cur > 1) p.set('p', cur);
        var qs = p.toString();
        try { history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
      }
      if (scroll) grid.scrollIntoView({ behavior: smooth, block: 'start' });
    }

    function readInputs() {
      state.groups = {};
      inputs.forEach(function (inp) {
        if (!isOn(inp)) return;
        var g = inp.getAttribute('data-filter-group');
        (state.groups[g] = state.groups[g] || []).push(inp.getAttribute('data-filter-value'));
      });
    }
    inputs.forEach(function (inp) {
      var ev = inp.type === 'checkbox' ? 'change' : 'click';
      inp.addEventListener(ev, function () {
        if (inp.type !== 'checkbox') setOn(inp, !isOn(inp));
        readInputs(); state.page = 1; apply(false, true);
      });
    });
    sortSels.forEach(function (sel) {
      sel.addEventListener('change', function () {
        state.sort = sel.value;
        sortSels.forEach(function (o) { if (o !== sel) o.value = sel.value; });
        state.page = 1; apply(false, true);
      });
    });

    function fmt(v) { return (root.getAttribute('data-currency') || '€') + Math.round(v) + (v >= priceMax ? '+' : ''); }
    function syncPrice() {
      if (!minIn || !maxIn) return;
      var lo = parseFloat(minIn.value), hi = parseFloat(maxIn.value);
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      if (minLbl) minLbl.textContent = fmt(lo);
      if (maxLbl) maxLbl.textContent = fmt(hi);
      minIn.setAttribute('aria-valuetext', fmt(lo));
      maxIn.setAttribute('aria-valuetext', fmt(hi));
      if (track) { track.style.left = (lo / priceMax * 100) + '%'; track.style.width = ((hi - lo) / priceMax * 100) + '%'; }
      state.min = lo > 0 ? lo : null;
      state.max = hi < priceMax ? hi : null;
    }
    if (minIn && maxIn) {
      ['input', 'change'].forEach(function (ev) {
        minIn.addEventListener(ev, function () { syncPrice(); if (ev === 'change') { state.page = 1; apply(false, true); } });
        maxIn.addEventListener(ev, function () { syncPrice(); if (ev === 'change') { state.page = 1; apply(false, true); } });
      });
      syncPrice();
    }
    function setSideOpen(open) {
      if (!side) return;
      side.classList.toggle('is-open', open);
      if (sideToggle) sideToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    // close the panel BEFORE scrolling so the scroll target is measured against the collapsed layout
    if (applyBtn) applyBtn.addEventListener('click', function () { setSideOpen(false); readInputs(); syncPrice(); state.page = 1; apply(true, true); });
    if (sideToggle && side) sideToggle.addEventListener('click', function () { setSideOpen(!side.classList.contains('is-open')); });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      state.groups = {}; state.min = null; state.max = null; state.page = 1;
      inputs.forEach(function (c) { setOn(c, false); });
      if (minIn) minIn.value = minIn.getAttribute('min') || 0;
      if (maxIn) maxIn.value = maxIn.getAttribute('max') || priceMax;
      syncPrice(); apply(false, true);
    });
    root.querySelectorAll('[data-mia-clear-inline]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); clearBtn && clearBtn.click(); }); });

    // Apply the paged view synchronously (first paint already matches: Liquid pre-hides cards beyond per_page),
    // then load every OTHER server page via the Section Rendering API and re-apply with the full set.
    function loadRest() {
      var total = parseInt(root.getAttribute('data-pages') || '1', 10);
      var current = parseInt(root.getAttribute('data-current-page') || '1', 10) || 1;
      var sectionId = root.getAttribute('data-section-id');
      updateCounts(); apply();
      // nothing to merge only when the single server page is the one we rendered; a landing on an out-of-range
      // ?page=N (empty Liquid page) still fetches page 1 so the collection is never shown empty
      if (!sectionId || (total <= 1 && current <= 1)) return;
      var reqs = [], failed = false;
      for (var p = 1; p <= total; p++) {
        if (p === current) continue;
        var u = new URL(location.pathname, location.origin);
        u.searchParams.set('section_id', sectionId);
        u.searchParams.set('page', p);
        reqs.push(fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        }).catch(function () { failed = true; return null; }));
      }
      Promise.all(reqs).then(function (htmls) {
        htmls.forEach(function (html) {
          if (html == null) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-mia-grid]');
          if (!g) { failed = true; return; }
          g.querySelectorAll('[data-mia-card]').forEach(function (c) { grid.appendChild(c); });
        });
      }).catch(function () { failed = true; }).then(function () {
        if (failed) {
          // some pages could not be merged: expose the server-side pagination as a fallback
          var lm = root.querySelector('[data-mia-loadmore]');
          if (lm) lm.style.display = 'block';
        }
        updateCounts(); apply();
      });
    }
    loadRest();
  }

  /* ---------- Tabs (FAQ / News) ---------- */
  function initTabs(root) {
    var buttons = root.querySelectorAll('[data-tab]');
    var items = root.querySelectorAll('[data-tab-item]');
    var empty = root.querySelector('[data-tab-empty]');
    function select(val) {
      buttons.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === val ? 'true' : 'false'); });
      var n = 0;
      items.forEach(function (it) {
        var cats = (it.getAttribute('data-tab-item') || '').split('|');
        var show = val === 'all' || cats.indexOf(val) > -1;
        it.hidden = !show; if (show) n++;
      });
      if (empty) empty.hidden = n > 0;
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-tab')); }); });
    select('all');
  }

  /* ---------- Product page: gallery thumbs + variant select ---------- */
  function initProduct(root) {
    var main = root.querySelector('[data-pd-main]');
    root.querySelectorAll('[data-pd-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-pd-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
        if (main) main.innerHTML = '<img src="' + b.getAttribute('data-src') + '" alt="' + (b.getAttribute('data-alt') || '') + '">';
      });
    });
    var sel = root.querySelector('[data-pd-variant]');
    var price = root.querySelector('[data-pd-price]');
    var btn = root.querySelector('[data-pd-add]');
    var idInput = root.querySelector('input[name="id"]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      if (idInput) idInput.value = o.value;
      if (price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
      if (btn) { var av = o.getAttribute('data-available') === 'true'; btn.disabled = !av; btn.textContent = av ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout'); }
    });
  }

  function initHash() {
    var smooth = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    function go() {
      if (!location.hash) return;
      var el = document.getElementById(location.hash.slice(1));
      if (el) { if (el.tagName === 'DETAILS') el.open = true; setTimeout(function () { el.scrollIntoView({ behavior: smooth, block: 'start' }); }, 100); }
    }
    go();
    window.addEventListener('hashchange', go);
  }

  function init() {
    initAgeGate();
    initAgeCheck();
    document.querySelectorAll('[data-mia-collection]').forEach(initGrid);
    document.querySelectorAll('[data-mia-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-mia-product]').forEach(initProduct);
    initHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mia-collection]').forEach(initGrid);
    e.target.querySelectorAll('[data-mia-tabs]').forEach(initTabs);
    e.target.querySelectorAll('[data-mia-product]').forEach(initProduct);
  });
})();
